import React, { useState, useEffect } from 'react';
import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';
import api from '../api/axios';

export default function QRPointsScanner() {
  const [scanResult, setScanResult] = useState(null);
  const [error, setError] = useState(null);
  const [isScanning, setIsScanning] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    let scanner = null;
    if (isScanning) {
      scanner = new Html5QrcodeScanner('qr-reader-points', {
        qrbox: { width: 250, height: 250 },
        fps: 8,
        supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
      });

      scanner.render(onScanSuccess, onScanError);
    }

    function onScanSuccess(resultText) {
      scanner.clear();
      setIsScanning(false);
      processStationScan(resultText);
    }

    function onScanError(err) {
      // Ignorar errores de cuadro
    }

    return () => {
      if (scanner) {
        scanner.clear().catch(e => console.error('Error al limpiar escáner:', e));
      }
    };
  }, [isScanning]);

  const processStationScan = async (qrData) => {
    setIsProcessing(true);
    setError(null);
    setScanResult(null);

    try {
      const response = await api.post('/points/register', { qrData });
      setScanResult(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Ocurrió un inconveniente al procesar el código QR. Por favor verifique el código e intente nuevamente.');
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4 sm:p-6 space-y-6 animate-fadeIn">
      {/* Scanner Header */}
      <div className="bg-gradient-to-r from-purple-900 to-indigo-950 text-white rounded-3xl p-6 sm:p-8 shadow-xl text-center space-y-2">
        <span className="bg-purple-500/20 text-purple-300 border border-purple-400/30 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
          Escáner de Estación
        </span>
        <h1 className="text-2xl sm:text-3xl font-extrabold">Registro de Puntos QR</h1>
        <p className="text-xs text-gray-300 max-w-md mx-auto">
          Apunte la cámara hacia el código QR de la estación para sumar puntos a su cuenta.
        </p>
      </div>

      {/* QR Scanner Camera Interface */}
      {isScanning && (
        <div className="bg-white rounded-3xl p-6 border border-gray-100 shadow-lg text-center space-y-4">
          <h3 className="font-bold text-gray-900 text-sm">Escaneando Código QR...</h3>
          <div id="qr-reader-points" className="w-full" />
        </div>
      )}

      {/* Processing Indicator */}
      {isProcessing && (
        <div className="p-8 text-center bg-white rounded-3xl border border-purple-100 shadow-sm space-y-3">
          <div className="w-10 h-10 border-4 border-purple-600 border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-sm font-bold text-gray-700">Validando su código e ingresando los puntos...</p>
        </div>
      )}

      {/* Success View */}
      {scanResult && (
        <div className="p-6 bg-emerald-50 border border-emerald-200 rounded-3xl text-emerald-900 shadow-sm space-y-4 text-center">
          <div className="text-4xl">🎉</div>
          <div>
            <h4 className="font-extrabold text-lg">{scanResult.message}</h4>
            <p className="text-xs text-emerald-700 mt-1">
              Estación: <strong>{scanResult.stationName}</strong> | Total acumulado: <strong className="text-sm font-black">{scanResult.totalPoints} pts</strong>
            </p>
          </div>
          <button
            onClick={() => {
              setScanResult(null);
              setIsScanning(true);
            }}
            className="w-full py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-2xl shadow transition-colors text-sm"
          >
            Escanear Otra Estación
          </button>
        </div>
      )}

      {/* Error View (Usted Tone) */}
      {error && (
        <div className="p-6 bg-red-50 border border-red-200 rounded-3xl text-red-900 shadow-sm space-y-4 text-center">
          <div className="text-4xl">⚠️</div>
          <div>
            <h4 className="font-extrabold text-base">Atención</h4>
            <p className="text-xs text-red-700 mt-1">{error}</p>
          </div>
          <button
            onClick={() => {
              setError(null);
              setIsScanning(true);
            }}
            className="w-full py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-2xl shadow transition-colors text-sm"
          >
            Reintentar Escaneo
          </button>
        </div>
      )}
    </div>
  );
}
